import * as API from '@/services/API';

export default {
  get(id) {
    return API.apiClient.get(`/family-member/${id}`);
  },
  getHistory(options) {
    if (typeof options === 'object') {
      const id = options.id;
      delete options.id;
      const query = API.apiHelper.getQueryStringFromObject(options);
      return API.apiClient.get(`/family-member/${id}/history${query}`);
    } else {
      return API.apiClient.get(`/family-member/${options}/history`);
    }
  },
  list(options) {
    const query = API.apiHelper.getQueryStringFromObject(options);
    return API.apiClient.get(`/family-member/${query}`);
  },
  paginate(link) {
    return API.apiClient.get(link);
  },
  search(options) {
    const query = API.apiHelper.getQueryStringFromObject(options);
    return API.apiClient.get(`/family-member/search${query}`);
  },
  async save(id, data) {
    if (id == 0) {
      return API.apiClient.post(`/family-member`, data);
    } else {
      return API.apiClient.put(`/family-member/${id}`, data);
    }
  },
  async delete(id) {
    return API.apiClient.delete(`/family-member/${id}`);
  }
};
